var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mevents-player"},[_c('div',{staticClass:"mevents-player__element"},[_c('div',{staticClass:"meventsPlayerElement",attrs:{"id":_vm.newPlayerId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }